<template>
  <div class="content" v-html="content"></div>
</template>
<script>
export default {
  data() {
    return {
      url: "api",
      type: 0,
      content: "",
    };
  },
  created() {
    document.title = "";
    this.setParamData();
    this.getUserAgreement();
    window.onload = function () {
      document.addEventListener("touchstart", function (event) {
        if (event.touches.length > 1) {
          event.preventDefault();
        }
      });
      document.addEventListener("gesturestart", function (event) {
        event.preventDefault();
      });
    };
  },
  methods: {
    //根据href地址解析参数
    setParamData() {
      let typeArray = window.location.href.split("&type=");
      if (typeArray.length > 1) {
        this.type = typeArray[1].split("#")[0];
      }
    },
    getUserAgreement() {
      let testRequest = new Request(
        this.url + "/mobile/bygUser/getUserAgreement",
        {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json;charset=UTF-8;",
            apiVersion: 2023032401,
          },
          body: JSON.stringify({
            data: this.type,
          }),
        }
      );
      fetch(testRequest)
        .then((response) => {
          return response.json();
        })
        .then((res) => {
          this.content = res.data;
        })
        .catch(function (err) {
          console.log(err);
        });
    },
  },
};
</script>

<style lang="stylus" scoped>
.content {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
}

>>> .content_text {
  font-size: 15px;
  color: #3b3b3b;
  font-weight: 400;
  overflow-y: auto;
  overflow-x: hidden;
  white-space: normal;
  word-break: break-all;
  word-wrap: break-word;
  margin: 20px 20px;
  line-height: 22px;
}

>>> .content_text_center {
  text-align: center;
}

>>> .content_text_right {
  text-align: right;
}

>>> .content_text_left {
  text-align: left;
}

>>> .content_text_line {
  white-space: pre-line;
}

>>> .content_text span {
  font-weight: 1000;
  color: #000000;
}

>>> .content_text_underline span {
  text-decoration: underline;
}

>>> .content_text i {
  margin-top: 1em;
  display: block;
}

>>> .content_text a {
  color: #3b8fd9;
}

>>> .content_text_table td {
  border-top: 1px solid windowtext;
  border-right: 1px solid windowtext;
  text-align: center;
  vertical-align: top;
  padding-top: 5px;
  font-size: 12px;
}

>>> .content_text_table tr:last-child td {
  border-bottom: 1px solid windowtext;
}

>>> .content_text_table tr td:first-child {
  border-left: 1px solid windowtext;
}
</style>
<style></style>


// WEBPACK FOOTER //
// src/pages/UserAgreement/UserAgreement.vue